'use strict';exports.__esModule = true;var _regexConstructor = require('./regexConstructor');var _regexConstructor2 = _interopRequireDefault(_regexConstructor);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var

CheckAgent = function CheckAgent() {_classCallCheck(this, CheckAgent);this.






  isMobileOrTablet = function (userAgent) {
    var userAgentRegex = _regexConstructor2.default.make(CheckAgent.MobileAgents);
    return userAgentRegex.test(userAgent);
  };this.

  isFirefox = function (userAgent) {
    var userAgentRegex = _regexConstructor2.default.make(CheckAgent.FirefoxAgent);
    return userAgentRegex.test(userAgent);
  };this.

  isInternetExplorer = function (userAgent) {
    var userAgentRegex = _regexConstructor2.default.make(CheckAgent.IEAgent);
    return userAgentRegex.test(userAgent);
  };this.

  isIPhone = function (userAgent) {
    var userAgentRegex = _regexConstructor2.default.make(CheckAgent.iPhoneAgent);
    return userAgentRegex.test(userAgent);
  };this.

  isAndroid = function (userAgent) {
    var userAgentRegex = _regexConstructor2.default.make(CheckAgent.AndroidAgent);
    return userAgentRegex.test(userAgent);
  };this.










  getIOsVersion = function (userAgent) {return parseFloat(
    ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(userAgent) || [0, ''])[1]).
    replace('undefined', '3_2').replace('_', '.').replace('_', '')) ||
    false;};} /*
               * Outputs a float representing the iOS version if user is using an iOS browser i.e. iPhone, iPad
               * Possible values include:
               * 3 - v3.0
               * 4.0 - v4.0
               * 4.14 - v4.1.4\
               * 10 - iPhone7
               * false - Not iOS
               */;CheckAgent.MobileAgents = ['Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'IEMobile', 'Opera Mini'];CheckAgent.AndroidAgent = ['Android'];CheckAgent.FirefoxAgent = ['Firefox'];CheckAgent.IEAgent = ['Trident'];CheckAgent.iPhoneAgent = ['iPhone'];exports.default = new CheckAgent();module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/checkUserAgent.js
// module id = 145
// module chunks = 0